export default {
  routes: [
    {
      name: 'works',
      path: '/directory/works',
      component: () => import('./views/TheWorks.vue'),

    },

    {
      name: 'work',
      path: '/directory/works/:uuid',
      component: () => import('./views/TheWork.vue'),
    },
  ]
}
